/*
    The values within this file indicate the index of each brand library value
    in an array of colors or fonts.

    These swatch indexes are how we create a consistent swatch mapping rule for styles.

    For example:
    ```
        // These values currently come from the Event Setting's `themeStyles` object
        const colorSwatches = [#ffffff, #000000, #A020F0, #eeeeee]
        const fontSwatches = ['Cats', 'Dogs', 'Foo', 'Bar']

        // If you want to access the default Brand Library Button Color
        const defaultButtonColor = colorSwatches[BRAND_LIBRARY_BUTTON_DEFAULT_COLOR];

        // If you want to access the default Brand Library Headline Font
        const defaultHeadlineFont = fontSwatches[BRAND_LIBRARY_HEADLINE_TEXT];
    ```
*/

export const BRAND_LIBRARY_DARK_TEXT_COLOR = 0;
export const BRAND_LIBRARY_LIGHT_TEXT_COLOR = 1;
export const BRAND_LIBRARY_BUTTON_DEFAULT_COLOR = 2;
export const BRAND_LIBRARY_BUTTON_HOVER_COLOR = 3;

export const BRAND_LIBRARY_HEADLINE_TEXT = 0;
export const BRAND_LIBRARY_SUBHEADLINE_TEXT = 1;
export const BRAND_LIBRARY_BODY_TEXT = 2;
export const BRAND_LIBRARY_BUTTON_TEXT = 3;
